import React, { PureComponent } from "react";

class InputDataAccount extends PureComponent {

    render() {

      const { Validaciones, ValidarPantalla, Cuenta, EsEdicion, tarjetas, guardarCampoCuenta } = this.props;

      let denominacionComponente;

      if (tarjetas.cliente.titulo) {
            denominacionComponente = <input type="text" className="form-control default-input"
                value={Cuenta.CuentaDenominacion}
                  onChange={(event) => guardarCampoCuenta(event.target.value, "CuentaDenominacion")} />;
      }
      else
      {
         denominacionComponente = <label className="alert-danger">{tarjetas.cliente.numeroDocumento}</label>;
      }


      let mensajeErrorDenominacion = null;
      let mensajeErrorDescripcion = null;
      let mensajeErrorPlanta = null;

      if (ValidarPantalla == true)
      {
         if (Validaciones.CuentaDenominacionSeleccionada == false) {
                mensajeErrorDenominacion = <label className="error">Debe completar la denominación</label>;
         }

         if (Validaciones.CuentaDenominacionRepetida == false) {
             mensajeErrorDenominacion = <label className="error">Este nombre ya existe</label>;
         }

         if (Validaciones.DescripcionSeleccionada == false) {
             mensajeErrorDescripcion = <label className="error">Debe completar la descripción</label>
         }

         if (Validaciones.PlantaSeleccionada == false) {
             mensajeErrorPlanta = <label className="error">Debe completar la planta</label>
         }

        }

        return (
        <div className="row bottom-separator-xs">
            {EsEdicion == false &&
                <div className="col-xs-12 bottom-separator-xs">
                    <ul className="no-bullets no-padding no-margin">
                        <li className="inlineListItem2 lg-margin">
                            <div className="default-checkbox">
                                <input id="check-descentralizada" type="checkbox" checked={Cuenta.checkDescentralizada}
                                    onChange={(event) => {
                                        guardarCampoCuenta(event.target.checked, "checkDescentralizada")
                                    }} />
                                <label className="label-primary" htmlFor="check-descentralizada"></label>
                            </div>
                        </li>
                        <li className="inlineListItem2">
                            <label className="label-primary" htmlFor="check-descentralizada">Descentralizada</label>
                        </li>
                    </ul>
                </div>
            }

            <div className="col-xs-12 bottom-separator-xs">
                <div className="row">
                    <div className="col-xs-8">
                        <label className="label-primary">Denominación de la cuenta</label>&nbsp;<label className="label-secondary">(novedad a enviar)</label>
                        {denominacionComponente}
                    </div>
                    <div className="col-xs-12">
                        {mensajeErrorDenominacion}
                    </div>
                </div>
            </div>

            <div className="col-xs-12 bottom-separator-xs">
                <div className="row">
                    <div className="col-xs-6">
                        <label className="label-primary">Descripción de la cuenta</label>&nbsp;<label className="label-secondary">(para identificarla en pantalla)</label>
                        <input type="text" placeholder="Cuenta Visa Corporate 3" className="form-control default-input"
                            value={Cuenta.Descripcion}
                            onChange={(event) => guardarCampoCuenta(event.target.value, "Descripcion")} />
                    </div>
                    <div className="col-xs-12">
                        {mensajeErrorDescripcion}
                    </div>
                </div>
            </div>

            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-6">
                        <label className="label-primary">Código de planta </label>
                        <input type="text" className="form-control default-input"
                            value={Cuenta.Planta}
                            onChange={(event) => guardarCampoCuenta(event.target.value, "Planta")} />
                    </div>
                    <div className="col-xs-12">
                        {mensajeErrorPlanta}
                    </div>
                </div>
            </div>
        </div>
        );

    }
    
}

export default InputDataAccount;
